import React from 'react';

import FacebookIcon from '@/components/UI/Icons/FacebookIcon';
import InstagramIcon from '@/components/UI/Icons/InstagramIcon';

const SOCIAL_LINKS = [
  {
    href: 'https://web.facebook.com/people/LuckyDays-Canada/61590422842909/',
    label: 'Facebook',
    Icon: FacebookIcon,
  },
  {
    href: 'https://www.instagram.com/luckydayscanada/',
    label: 'Instagram',
    Icon: InstagramIcon,
  },
];

export function FooterSocialLinks(): JSX.Element {
  return (
    <div className="mt-6 flex gap-4">
      {SOCIAL_LINKS.map(({ href, label, Icon }) => (
        <a
          key={label}
          href={href}
          target="_blank"
          rel="noopener noreferrer"
          aria-label={label}
          className="text-white/80 transition-colors hover:text-white"
        >
          <Icon width={32} height={32} />
        </a>
      ))}
    </div>
  );
}
